// Class sets for `rowLink` rows and the parts of a row that swap on hover or keyboard focus.

/** On the row's link (or a card header's button): stretches its hit area and focus ring over the `relative` parent. */
export const STRETCHED_OVERLAY_CLASS =
  'after:absolute after:inset-0 focus-visible:after:ring-2 focus-visible:after:ring-inset focus-visible:after:ring-focus-ring';

/** Fades in with the row's hover or keyboard focus; always shown where there is no hover (touch). */
export const ROW_REVEAL_CLASS =
  'opacity-0 motion-safe:transition-opacity group-hover/row:opacity-100 group-has-[:focus-visible]/row:opacity-100 [@media(hover:none)]:opacity-100';

/** The counterpart that `ROW_REVEAL_CLASS` replaces in the same spot. */
export const ROW_CONCEAL_CLASS =
  'opacity-100 motion-safe:transition-opacity group-hover/row:opacity-0 group-has-[:focus-visible]/row:opacity-0 [@media(hover:none)]:opacity-0';
